<template>
	<div class="header" :class="{active:isLoadSuccess}">
		<img class="bg" @load="loadimg" src="@/assets/image/layout/header2.png" alt="" />
		<el-row>
			<el-col :span="5" class="item1 flex flex-align-center">
				<div @click="getHome" class="item2">
					<img class="logo" src="@/assets/image/logo.png" alt="" />
					<!-- 桥梁监测系统 -->
				</div>
				<div class="riqi flex">
					<div class="text1">{{ weatherWenzi }}</div>
					<div class="text2">{{ wendu }}℃</div>
				</div>
				<!-- <el-button v-if="locale" class="swagger" type="text" @click="swagger">swagger</el-button> -->
			</el-col>
			<el-col :span="14" class="item1">
				<!-- <home-route-two v-if="this.$route.path.indexOf('home') == -1"></home-route-two>
				<div v-else>&nbsp;</div> -->
				<img class="title" v-if="$route.path.indexOf('allBridges') == -1" src="@/assets/image/layout/title.png" alt="" />
				<img class="title" v-else src="@/assets/image/layout/title2.png" alt="" />
			</el-col>
			<el-col :span="5" class="item3 flex flex-align-center">
				<div class="riqi flex">
					<div class="text1">{{ date }} 周{{ week }}</div>
					<div class="text2">{{ dateTime }}</div>
				</div>
				<div></div>
				<div>
					<el-dropdown>
						<span class="el-dropdown-link"><img src="@/assets/image/user.png" alt="" class="imgUser" /></span>
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item @click.native="$router.push('/home/usercenter')">个人中心</el-dropdown-item>
							<el-dropdown-item @click.native="loginOut">退出登录</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>
				</div>
				<!-- <div class="backClass">
          <a href="https://sz.deqing.gov.cn:8085/web/#/navigation">返回</a>
        </div> -->

				<div v-if="backBut === 2" style="margin-left: 10px;" @click="backClick">返回</div>
			</el-col>
		</el-row>
	</div>
</template>

<script>
import { strictEqual } from 'assert';
import dayjs from 'dayjs';
import HomeRouteTwo from '../../FacilityBim/HomeRouteTwo.vue';
import config from '@/api/config';
export default {
	data() {
		return {
			weatherWenzi: '',
			wendu: '',
			date: '',
			week: '',
			dateTime: '',
			timer: null,
			isLoadSuccess: false,
			backBut: this.$store.state.backBut
		};
	},
	computed: {
		locale() {
			if (location.host.indexOf('local') !== -1 || location.host.indexOf('192.168') !== -1) {
				return true;
			} else {
				return false;
			}
		}
	},
	components: { HomeRouteTwo },
	created() {
		this.timer = null;
		this.dateTime = dayjs(new Date()).format('HH:mm:ss');
		this.timer = setInterval(() => {
			this.dateTime = dayjs(new Date()).format('HH:mm:ss');
		}, 1000);
	},
	mounted() {
		this.weather();
		this.getDate();
		console.log(this.backBut);
	},
	methods: {
		//获取天气
		weather() {
			//加载天气查询插件
			AMap.plugin('AMap.Weather', () => {
				//创建天气查询实例
				var weather = new AMap.Weather();
				//执行实时天气信息查询
				weather.getLive('诸暨市', (err, data) => {
					this.wendu = data.temperature;
					this.weatherWenzi = data.weather;
				});
			});
		},
		//获取时间 （月，日） 星期
		getDate() {
			this.date = dayjs(new Date()).format('MM月DD日');
			let obj = {
				1: '一',
				2: '二',
				3: '三',
				4: '四',
				5: '五',
				6: '六',
				7: '日'
			};

			this.week = obj[dayjs().day()];
		},
		//跳转首页
		getHome() {
			this.$router.push('/layout');
		},
		//返回首页
		loginOut() {
			this.$router.push('/login');
		},
		swagger() {
			window.open(`${config.host}/doc.html#/home`);
		},
		// 返回
		backClick() {
			// window.location.href = 'https://sz.deqing.gov.cn:8085/web/#/navigation';
			window.location.go(-1)
		},
		loadimg() {
			console.log('haha');
			this.isLoadSuccess=true;
		}
	},
	destroyed() {
		clearInterval(this.timer);
	}
};
</script>
<style lang="scss" scoped>
.backClass {
	margin-left: 20px;
	a {
		line-height: 100%;
		color: #fff;
		text-decoration: none;
	}
}

.header {
	width: 100%;
	height: 268px;
	background: url('~@/assets/image/layout/header.png') no-repeat;
	background-size: 100% 100%;
	// line-height: 90px;
	position: absolute;
	top: 0;
	z-index: 99;
	.bg {
		width: 100%;
		position: absolute;
		left: 0;
		top: 0;
		opacity: 0;
	}
	&.active{
		background: none;
		.bg{
			opacity: 1;
		}
	}
	.logo {
		width: 88px;
		height: 40px;
		margin-right: 20px;
	}
	.title {
		display: block;
		margin: 18px auto;
		width: 320px;
	}
	.riqi {
		// height: 104px;
		line-height: 20px;
		box-sizing: border-box;
		// padding-top: 18px;
		text-align: center;
		margin: 0 10px;
		font-size: 18px;
		.text2 {
			font-size: 18px;
		}
	}
}

.item3 {
	text-align: right;
	color: white;
	padding-right: 30px;
	box-sizing: border-box;
	display: flex;
	justify-content: flex-end;
	line-height: 60px;
}
.item1 {
	padding: 12px 30px;
	box-sizing: border-box;
	text-align: left;
	color: white;
	display: flex;
	.home {
		margin-right: 40px;
		display: flex;
		align-items: center;
		flex-direction: column;
		justify-content: center;
		cursor: pointer;
		// line-height: 0px;
		img {
			width: 20px;
			height: 20px;
			margin-bottom: 5px;
			// vertical-align: text-bottom;
			// margin-right: 3px;
		}
	}
}
.item2 {
	font-family: YouSheBiaoTiHei;
	font-size: 36px;
	color: white;
	text-align: left;
	line-height: 90px;
	display: flex;
	align-items: center;
}
.tianqi {
	display: flex;
	align-items: center;
	flex-direction: column;
	justify-content: center;
	line-height: 20px;
	// height: 104px;
	// line-height: 25px;
	// box-sizing: border-box;
	// padding-top: 15px;
	// width: 60px;
}
.img2 {
	width: 20px;
	height: 20px;
	margin-left: 30px;
}

.imgUser {
	width: 40px;
	height: 40px;
	margin-left: 30px;
}
::v-deep .el-badge__content {
	background: transparent;
	top: 16px;
}
.swagger {
	line-height: 50px;
	margin-left: 50px;
	font-size: 20px;
	cursor: pointer;
	color: #fff;
}
</style>
